"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var Collapse_1 = __importDefault(require("@mui/material/Collapse"));
var Alert_1 = __importDefault(require("@mui/material/Alert"));
var Lang_js_1 = require("../Lang.js");
var mountIsland_1 = require("../mountIsland");
// Site-specific dark navy not represented in the MUI palette
var NAVY = '#1c1c3c';
// Accepts both Y-m-d and MySQL DATETIME. Splitting a DATETIME on '-' leaves the time attached
// to the day component, which parses as NaN and renders literally as "Invalid Date", so take
// the date part first. WordPress/PMS columns also use the zero-date sentinel in both widths.
function formatDate(dateStr, format) {
    if (format === void 0) { format = 'full'; }
    var datePart = (dateStr !== null && dateStr !== void 0 ? dateStr : '').trim().split(' ')[0].split('T')[0];
    if (!datePart || datePart === '0000-00-00')
        return '';
    var _a = datePart.split('-').map(Number), y = _a[0], m = _a[1], d = _a[2];
    if (!y || !m || !d)
        return '';
    var date = new Date(y, m - 1, d);
    if (isNaN(date.getTime()))
        return '';
    if (format === 'monthYear') {
        return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    }
    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}
function isRenewalEligible(renewalDate) {
    if (!renewalDate || renewalDate === '0000-00-00')
        return false;
    var _a = renewalDate.split('-').map(Number), y = _a[0], m = _a[1], d = _a[2];
    var renewal = new Date(y, m - 1, d);
    var now = new Date();
    var diffMs = renewal.getTime() - now.getTime();
    var diffDays = diffMs / (1000 * 60 * 60 * 24);
    return diffDays <= 183;
}
function getRenewAfterDate(renewalDate) {
    if (!renewalDate || renewalDate === '0000-00-00')
        return '';
    var _a = renewalDate.split('-').map(Number), y = _a[0], m = _a[1], d = _a[2];
    var date = new Date(y, m - 1, d);
    date.setDate(date.getDate() - 183);
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}
// Display names for the description-language switcher (self-labeled, so each
// option reads in its own language regardless of the page UI locale).
var DESC_LANG_NAMES = {
    en: 'English',
    es: 'Español',
    pt: 'Português',
    fr: 'Français',
    bg: 'български',
};
/**
 * Collapsible details for a subscription row. Renders nothing when the
 * backend didn't return any product info (empty description AND empty note) —
 * so a missing Spanish slug or unmapped product just hides the block rather
 * than showing an empty accordion.
 *
 * Description + purchase_note come from the MSIA Store (WooCommerce product
 * `post_content` and `_purchase_note` postmeta). They are HTML-authored by
 * admins in WP, so we render via dangerouslySetInnerHTML.
 */
var ProductDetails = function (_a) {
    var _b;
    var info = _a.info, onLangChange = _a.onLangChange;
    var _c = (0, react_1.useState)(false), open = _c[0], setOpen = _c[1];
    // Description language switcher: default to the page UI language when a
    // matching variant exists, else the first published variant. The page chrome
    // stays in en/es — only the description copy switches.
    var variants = info.descriptions || {};
    var langCodes = Object.keys(variants);
    var initialLang = variants[Lang_js_1.lang] ? Lang_js_1.lang : (langCodes[0] || '');
    var _d = (0, react_1.useState)(initialLang), descLang = _d[0], setDescLang = _d[1];
    var descHtml = (_b = variants[descLang]) !== null && _b !== void 0 ? _b : info.description;
    // Report the chosen edition-language up so a renew link can carry it (the
    // cart gates Book format on French/Bulgarian editions).
    (0, react_1.useEffect)(function () { onLangChange === null || onLangChange === void 0 ? void 0 : onLangChange(descLang); }, [descLang]);
    if (!descHtml && !info.purchase_note)
        return null;
    return (react_1.default.createElement(Box_1.default, { sx: {
            mt: '4px',
            backgroundColor: '#fff',
            borderRadius: 2,
            boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
            overflow: 'hidden',
        } },
        react_1.default.createElement(Box_1.default, { onClick: function () { return setOpen(!open); }, sx: {
                cursor: 'pointer',
                p: '10px 18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                fontSize: '13px',
                fontWeight: 600,
                color: NAVY,
                '&:hover': { backgroundColor: 'rgba(0,0,0,0.02)' },
            } },
            react_1.default.createElement("span", null, open ? (0, Lang_js_1.__)('Hide details') : (0, Lang_js_1.__)('View details')),
            react_1.default.createElement("span", { style: { fontSize: '12px' } }, open ? '▲' : '▼')),
        react_1.default.createElement(Collapse_1.default, { in: open },
            react_1.default.createElement(Box_1.default, { sx: { p: '0 20px 18px 20px', fontSize: '14px', lineHeight: 1.6, color: '#333' } },
                langCodes.length > 1 && (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', flexWrap: 'wrap', gap: '12px', mb: '14px', pb: '2px' } }, langCodes.map(function (code) { return (react_1.default.createElement(Box_1.default, { key: code, component: "button", type: "button", onClick: function () { return setDescLang(code); }, sx: {
                        border: 0,
                        background: 'none',
                        p: 0,
                        cursor: 'pointer',
                        fontSize: '12px',
                        lineHeight: 1.4,
                        color: code === descLang ? NAVY : '#8a8a8a',
                        fontWeight: code === descLang ? 700 : 400,
                        textDecoration: code === descLang ? 'underline' : 'none',
                    } }, DESC_LANG_NAMES[code] || code)); }))),
                descHtml && (react_1.default.createElement(Box_1.default, { sx: { '& p:first-of-type': { mt: 0 }, '& p:last-of-type': { mb: 0 } }, dangerouslySetInnerHTML: { __html: descHtml } })),
                info.purchase_note && (react_1.default.createElement(Box_1.default, { sx: {
                        mt: info.description ? '12px' : 0,
                        pt: info.description ? '12px' : 0,
                        borderTop: info.description ? '1px solid #eee' : 'none',
                        fontSize: '13px',
                        color: '#555',
                    } },
                    react_1.default.createElement(Box_1.default, { sx: { '& p:first-of-type': { mt: 0 }, '& p:last-of-type': { mb: 0 } }, dangerouslySetInnerHTML: { __html: info.purchase_note } })))))));
};
var SubscriptionPortal = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var container = document.getElementById('student-subscriptions-portal');
    var dataset = (container === null || container === void 0 ? void 0 : container.dataset) || {};
    // Role data comes from Blade data attributes. An absent member id stays absent — falling back
    // to a placeholder here is what displayed "MEMBER ID: 123" to every account whose id was empty.
    var memberId = dataset.memberId || '';
    var isInitiate = dataset.isInitiate === '1';
    var isMinister = dataset.isMinister === '1';
    var isDiscourse = dataset.isDiscourse === '1';
    var isSat = dataset.isSat === '1';
    // Logged-out visitors see the same products and prices; only the actions differ.
    var isGuest = dataset.isGuest === '1';
    // Edition-language chosen in each details panel, carried to the renew link so the
    // cart opens on the language the member actually picked. Carried for every language,
    // not just the digital-only FR/BG editions: without it the cart falls back to the
    // page's ?lang=, so picking Português on an ?lang=en page silently opened an English
    // cart (and a Spanish one from ?lang=es).
    var _t = (0, react_1.useState)(''), discourseEdition = _t[0], setDiscourseEdition = _t[1];
    var _u = (0, react_1.useState)(''), satEdition = _u[0], setSatEdition = _u[1];
    // Append the picked edition when there is one; harmless when it matches the page
    // language, and it removes the URL-dependent fallback entirely.
    // A guest is sent to login carrying the cart they asked for as previous_url, so they land
    // in that cart rather than on the dashboard. WordPressAuthService honours any path
    // beginning with "/", which is why the cart URL is passed whole rather than as params.
    var cartHref = function (product, edition) {
        var cart = "/app/subscriptions/cart?product=".concat(product).concat(edition ? "&edition=".concat(edition) : '');
        return isGuest
            ? "/app/students/login?previous_url=".concat(encodeURIComponent(cart))
            : cart;
    };
    var actionLabel = function (subscribed) {
        if (isGuest)
            return (0, Lang_js_1.__)('SIGN IN TO SUBSCRIBE');
        return subscribed ? (0, Lang_js_1.__)('RENEW NOW') : (0, Lang_js_1.__)('SUBSCRIBE NOW');
    };
    // Controller redirects carry outcome codes as query params (no session store on
    // Lambda, so Laravel flash messages never survive a redirect in this app).
    var noticeCode = new URLSearchParams(window.location.search).get('notice');
    var NOTICES = {
        pms_subscription: { severity: 'info', message: (0, Lang_js_1.__)('You already have a That Which Is subscription on our previous billing system, so a new one cannot be started. It is shown below — contact us if you need to make a change to it.') },
    };
    var notice = noticeCode ? NOTICES[noticeCode] : undefined;
    var subscriptionsRaw = dataset.subscriptions;
    var subscriptions = null;
    try {
        subscriptions = subscriptionsRaw ? JSON.parse(subscriptionsRaw) : null;
    }
    catch (e) {
        console.warn('Failed to parse subscription data', e);
    }
    var data = subscriptions ? {
        member_id: memberId,
        statuses: {
            initiate: { active: isInitiate },
            minister: { active: isMinister },
            discourse: isDiscourse,
            sat: isSat,
        },
        discourses: {
            subscribed: isDiscourse && !!subscriptions.discourse,
            lapsed: !isDiscourse && !!subscriptions.discourse,
            current_year: ((_a = subscriptions.discourse) === null || _a === void 0 ? void 0 : _a.curryear) || 0,
            expires: subscriptions.discourse ? formatDate(subscriptions.discourse.renewal_needed_by, 'monthYear') : null,
            renew_after: subscriptions.discourse ? getRenewAfterDate(subscriptions.discourse.renewal_needed_by) : null,
            renewal_eligible: subscriptions.discourse ? isRenewalEligible(subscriptions.discourse.renewal_needed_by) : false,
            status: ((_b = subscriptions.discourse) === null || _b === void 0 ? void 0 : _b.substatus) || 'Not Subscribed',
            completed: (((_c = subscriptions.discourse) === null || _c === void 0 ? void 0 : _c.curryear) || 0) >= 12,
        },
        sats: {
            subscribed: isSat && ((_d = subscriptions.sats) === null || _d === void 0 ? void 0 : _d.length) > 0,
            lapsed: !isSat && ((_e = subscriptions.sats) === null || _e === void 0 ? void 0 : _e.length) > 0,
            primary: ((_g = (_f = subscriptions.sats) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.primstat) === 'Primary',
            expires: ((_h = subscriptions.sats) === null || _h === void 0 ? void 0 : _h[0]) ? formatDate(subscriptions.sats[0].renewal_needed_by, 'monthYear') : null,
            renew_after: ((_j = subscriptions.sats) === null || _j === void 0 ? void 0 : _j[0]) ? getRenewAfterDate(subscriptions.sats[0].renewal_needed_by) : null,
            renewal_eligible: ((_k = subscriptions.sats) === null || _k === void 0 ? void 0 : _k[0]) ? isRenewalEligible(subscriptions.sats[0].renewal_needed_by) : false,
            status: ((_m = (_l = subscriptions.sats) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m.substatus) || 'Not Subscribed',
            discourse_completed: false,
        },
        twi: {
            subscribed: ((_o = subscriptions.twi) === null || _o === void 0 ? void 0 : _o.status) === 'active',
            lapsed: !!subscriptions.twi && ((_p = subscriptions.twi) === null || _p === void 0 ? void 0 : _p.status) !== 'active',
            plan: ((_q = subscriptions.twi) === null || _q === void 0 ? void 0 : _q.plan_name) || '',
            // Next billing and expiry are different facts and must not share a field: a live
            // subscription has a next charge date, a lapsed one has an end date.
            next_payment: formatDate((_r = subscriptions.twi) === null || _r === void 0 ? void 0 : _r.next_billing_date),
            expired_on: formatDate((_s = subscriptions.twi) === null || _s === void 0 ? void 0 : _s.expiration_date),
            manage_url: '/app/twi/subscriptions',
        },
        product_info: subscriptions.product_info || {
            discourse: { title: '', description: '', purchase_note: '' },
            sat: { title: '', description: '', purchase_note: '' },
            twi: { title: '', description: '', purchase_note: '' },
        },
    } : {
        // No payload: say nothing rather than something. This branch used to spread MOCK_DATA,
        // which asserted a complete membership record as the member's own — an active Discourse
        // subscription in year 7 expiring May 2026, and member id 123 — to anyone whose data
        // failed to arrive. A member cannot tell invented facts from their own, so an empty
        // payload has to render as empty.
        member_id: memberId,
        statuses: {
            initiate: { active: isInitiate },
            minister: { active: isMinister },
            discourse: isDiscourse,
            sat: isSat,
        },
        discourses: {
            subscribed: false,
            lapsed: false,
            current_year: 0,
            expires: null,
            renew_after: null,
            renewal_eligible: false,
            status: 'Not Subscribed',
            completed: false,
        },
        sats: {
            subscribed: false,
            lapsed: false,
            primary: false,
            expires: null,
            renew_after: null,
            renewal_eligible: false,
            status: 'Not Subscribed',
            discourse_completed: false,
        },
        twi: {
            subscribed: false,
            lapsed: false,
            plan: '',
            next_payment: null,
            expired_on: null,
            manage_url: '/app/twi/subscriptions',
        },
        product_info: {
            discourse: { title: '', description: '', purchase_note: '' },
            sat: { title: '', description: '', purchase_note: '' },
            twi: { title: '', description: '', purchase_note: '' },
        },
    };
    // Shared sx for subscription action links
    var actionLinkSx = function (disabled) { return ({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: disabled ? 'grey.300' : NAVY,
        color: disabled ? 'text.disabled' : '#fff',
        border: 'none',
        borderRadius: 1.5,
        px: 3.5,
        height: '42px',
        fontSize: '14px',
        fontWeight: 700,
        cursor: disabled ? 'not-allowed' : 'pointer',
        whiteSpace: 'nowrap',
        transition: 'background-color 0.2s ease',
        letterSpacing: '0.5px',
        minWidth: '160px',
        textDecoration: 'none',
        '&:hover': {
            backgroundColor: disabled ? 'grey.300' : '#2a2a4c',
            textDecoration: 'none',
            color: disabled ? 'text.disabled' : '#fff',
        },
    }); };
    // Shared sx for subscription row cards
    var rowCardSx = {
        backgroundColor: '#fff',
        borderRadius: 2,
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        p: '20px 24px',
        display: 'flex',
        gap: 3,
        transition: 'box-shadow 0.2s ease',
        '&:hover': {
            boxShadow: '0 3px 10px rgba(0,0,0,0.1)',
        },
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        '& > a': {
            width: { xs: '100%', sm: 'auto' },
        },
    };
    return (react_1.default.createElement(Box_1.default, { sx: {
            p: 2,
            maxWidth: '1200px',
            mx: 'auto',
            backgroundColor: '#f5f6f8',
        } },
        notice && (react_1.default.createElement(Alert_1.default, { severity: notice.severity, sx: { mb: 2 } }, notice.message)),
        react_1.default.createElement(Box_1.default, { sx: {
                backgroundColor: '#fff',
                p: '10px 16px',
                borderRadius: 1.5,
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                mb: 2,
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '10px',
            } }, isGuest ? (react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', color: 'text.secondary' } },
            (0, Lang_js_1.__)('Browsing as a guest.'),
            ' ',
            react_1.default.createElement(Link_1.default, { href: "/app/students/login?previous_url=".concat(encodeURIComponent('/app/subscriptions/manage')), sx: { fontWeight: 600, color: NAVY } }, (0, Lang_js_1.__)('Sign in')),
            ' ',
            (0, Lang_js_1.__)('to see your own subscriptions and renewal dates.'))) : (react_1.default.createElement(react_1.default.Fragment, null,
            !!data.member_id && react_1.default.createElement(Box_1.default, { sx: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    backgroundColor: NAVY,
                    color: '#fff',
                    px: '14px',
                    py: '6px',
                    borderRadius: '20px',
                    fontSize: '13px',
                    fontWeight: 600,
                    letterSpacing: '0.3px',
                } },
                (0, Lang_js_1.__)('MEMBER ID'),
                ": ",
                data.member_id),
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' } },
                react_1.default.createElement(Box_1.default, { sx: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        backgroundColor: data.statuses.initiate.active
                            ? 'rgba(25, 148, 32, 0.08)'
                            : 'rgba(211, 47, 47, 0.08)',
                        px: '12px',
                        py: '6px',
                        borderRadius: '20px',
                    } },
                    react_1.default.createElement(Box_1.default, { component: "span", sx: {
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: data.statuses.initiate.active ? 'success.main' : 'error.main',
                            display: 'inline-block',
                        } }),
                    react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '13px', fontWeight: 500, color: '#333' } }, (0, Lang_js_1.__)('Initiate'))),
                react_1.default.createElement(Box_1.default, { sx: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        backgroundColor: data.statuses.minister.active
                            ? 'rgba(25, 148, 32, 0.08)'
                            : 'rgba(211, 47, 47, 0.08)',
                        px: '12px',
                        py: '6px',
                        borderRadius: '20px',
                    } },
                    react_1.default.createElement(Box_1.default, { component: "span", sx: {
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: data.statuses.minister.active ? 'success.main' : 'error.main',
                            display: 'inline-block',
                        } }),
                    react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '13px', fontWeight: 500, color: '#333' } }, (0, Lang_js_1.__)('Minister'))),
                react_1.default.createElement(Box_1.default, { sx: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        backgroundColor: data.statuses.discourse
                            ? 'rgba(25, 148, 32, 0.08)'
                            : 'rgba(211, 47, 47, 0.08)',
                        px: '12px',
                        py: '6px',
                        borderRadius: '20px',
                    } },
                    react_1.default.createElement(Box_1.default, { component: "span", sx: {
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: data.statuses.discourse ? 'success.main' : 'error.main',
                            display: 'inline-block',
                        } }),
                    react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '13px', fontWeight: 500, color: '#333' } }, (0, Lang_js_1.__)('Discourse Subscriber'))),
                react_1.default.createElement(Box_1.default, { sx: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        backgroundColor: data.statuses.sat
                            ? 'rgba(25, 148, 32, 0.08)'
                            : 'rgba(211, 47, 47, 0.08)',
                        px: '12px',
                        py: '6px',
                        borderRadius: '20px',
                    } },
                    react_1.default.createElement(Box_1.default, { component: "span", sx: {
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: data.statuses.sat ? 'success.main' : 'error.main',
                            display: 'inline-block',
                        } }),
                    react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '13px', fontWeight: 500, color: '#333' } }, (0, Lang_js_1.__)('SAT Subscriber'))))))),
        react_1.default.createElement(Box_1.default, { sx: { display: 'flex', flexDirection: 'column', gap: '14px' } },
            react_1.default.createElement(Box_1.default, null,
                react_1.default.createElement(Box_1.default, { sx: rowCardSx },
                    react_1.default.createElement(Box_1.default, { component: "img", src: "https://cdn.msia.org/shop/wp-content/uploads/sites/9/2008/06/2020-discourses-cropped-600x600.jpeg", alt: "Discourses", sx: {
                            width: '120px',
                            height: '120px',
                            minWidth: '120px',
                            objectFit: 'contain',
                            borderRadius: 2.5,
                        } }),
                    react_1.default.createElement(Box_1.default, { sx: { flex: 1, minWidth: 0 } },
                        react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h6", sx: { m: 0, fontSize: '18px', fontWeight: 700, color: NAVY } }, (0, Lang_js_1.__)('Discourses')),
                        data.discourses.completed ? (react_1.default.createElement(Typography_1.default, { sx: {
                                mt: '6px',
                                color: '#1a6e1e',
                                fontWeight: 600,
                                fontSize: '14px',
                            } }, (0, Lang_js_1.__)('You have completed all 12 years of Discourses. No further renewal is needed.'))) : data.discourses.subscribed ? (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 3, flexWrap: 'wrap', mt: '6px', fontSize: '14px', color: 'text.secondary' } },
                            react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'text.secondary' } },
                                react_1.default.createElement("strong", null,
                                    (0, Lang_js_1.__)('Year'),
                                    ":"),
                                " ",
                                data.discourses.current_year),
                            react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'text.secondary' } },
                                react_1.default.createElement("strong", null,
                                    (0, Lang_js_1.__)('Expires'),
                                    ":"),
                                " ",
                                data.discourses.expires),
                            react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'text.secondary' } },
                                react_1.default.createElement("strong", null,
                                    (0, Lang_js_1.__)('Renew After'),
                                    ":"),
                                " ",
                                data.discourses.renew_after))) : (react_1.default.createElement(Typography_1.default, { sx: { mt: '6px', color: 'error.main', fontWeight: 600, fontSize: '14px' } }, data.discourses.lapsed ? (0, Lang_js_1.__)('Expired') : (0, Lang_js_1.__)('Not Yet Subscribed'))),
                        data.discourses.subscribed && !data.discourses.completed && !data.discourses.renewal_eligible && (react_1.default.createElement(Typography_1.default, { sx: {
                                mt: 1,
                                fontSize: '13px',
                                color: 'error.main',
                                fontStyle: 'italic',
                            } }, (0, Lang_js_1.__)('Available for renewal if within 6 months of expiration')))),
                    !data.discourses.completed && (function () {
                        var disabled = data.discourses.subscribed && !data.discourses.renewal_eligible;
                        return (react_1.default.createElement(Link_1.default, { href: disabled ? undefined : cartHref('discourse', discourseEdition), onClick: function (e) { if (disabled)
                                e.preventDefault(); }, sx: actionLinkSx(disabled) }, actionLabel(data.discourses.subscribed)));
                    })()),
                react_1.default.createElement(ProductDetails, { info: data.product_info.discourse, onLangChange: setDiscourseEdition })),
            react_1.default.createElement(Box_1.default, null,
                react_1.default.createElement(Box_1.default, { sx: rowCardSx },
                    react_1.default.createElement(Box_1.default, { component: "img", src: "https://cdn.msia.org/shop/wp-content/uploads/sites/9/2008/06/Screenshot_20210415-145121_MSIA-1-1-600x600.jpg", alt: "SATs", sx: {
                            width: '120px',
                            height: '120px',
                            minWidth: '120px',
                            objectFit: 'contain',
                            borderRadius: 2.5,
                        } }),
                    react_1.default.createElement(Box_1.default, { sx: { flex: 1, minWidth: 0 } },
                        react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h6", sx: { m: 0, fontSize: '18px', fontWeight: 700, color: NAVY } }, (0, Lang_js_1.__)('SATs')),
                        data.sats.subscribed ? (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 3, flexWrap: 'wrap', mt: '6px' } },
                            react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'text.secondary' } },
                                react_1.default.createElement("strong", null,
                                    (0, Lang_js_1.__)('Expires'),
                                    ":"),
                                " ",
                                data.sats.expires),
                            react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'text.secondary' } },
                                react_1.default.createElement("strong", null,
                                    (0, Lang_js_1.__)('Renew After'),
                                    ":"),
                                " ",
                                data.sats.renew_after),
                            data.sats.primary && (react_1.default.createElement(Typography_1.default, { component: "span", sx: { color: 'info.main', fontWeight: 600, fontSize: '14px' } },
                                "\u2605 ",
                                (0, Lang_js_1.__)('Primary'))))) : (react_1.default.createElement(Typography_1.default, { sx: { mt: '6px', color: 'error.main', fontWeight: 600, fontSize: '14px' } }, data.sats.lapsed ? (0, Lang_js_1.__)('Expired') : (0, Lang_js_1.__)('Not Yet Subscribed'))),
                        !isGuest && data.discourses.current_year < 1 && (react_1.default.createElement(Typography_1.default, { sx: {
                                mt: 1,
                                fontSize: '13px',
                                color: 'error.main',
                                fontStyle: 'italic',
                            } }, (0, Lang_js_1.__)('SAT subscription becomes available after you start Year 1 of Discourses.')))),
                    (function () {
                        var discourseEligible = data.discourses.current_year >= 1;
                        // A guest's Discourse year is unknown, so the eligibility gate cannot be
                        // applied yet — the button takes them to login and the real gate runs
                        // once we know who they are.
                        var disabled = !isGuest && (!discourseEligible
                            || (data.sats.subscribed && !data.sats.renewal_eligible));
                        return (react_1.default.createElement(Link_1.default, { href: disabled ? undefined : cartHref('sat', satEdition), onClick: function (e) { if (disabled)
                                e.preventDefault(); }, sx: actionLinkSx(disabled) }, actionLabel(data.sats.subscribed)));
                    })()),
                react_1.default.createElement(ProductDetails, { info: data.product_info.sat, onLangChange: setSatEdition })),
            react_1.default.createElement(Box_1.default, { sx: rowCardSx },
                react_1.default.createElement(Box_1.default, { component: "img", src: "https://now.cdn.msia.org/images/TWI_Logo%20runded.png", alt: "That Which Is", sx: {
                        width: '120px',
                        height: '120px',
                        minWidth: '120px',
                        objectFit: 'contain',
                        borderRadius: 2.5,
                    } }),
                react_1.default.createElement(Box_1.default, { sx: { flex: 1, minWidth: 0 } },
                    react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h6", sx: { m: 0, fontSize: '18px', fontWeight: 700, color: NAVY } }, (0, Lang_js_1.__)('That Which Is')),
                    data.twi.subscribed ? (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 3, flexWrap: 'wrap', mt: '6px' } },
                        react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'text.secondary' } },
                            react_1.default.createElement("strong", null,
                                (0, Lang_js_1.__)('Plan'),
                                ":"),
                            " ",
                            data.twi.plan),
                        data.twi.next_payment && (react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'text.secondary' } },
                            react_1.default.createElement("strong", null,
                                (0, Lang_js_1.__)('Next Billing'),
                                ":"),
                            " ",
                            data.twi.next_payment)))) : data.twi.lapsed ? (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 3, flexWrap: 'wrap', mt: '6px' } },
                        react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'error.main', fontWeight: 600 } }, (0, Lang_js_1.__)('Expired')),
                        data.twi.expired_on && (react_1.default.createElement(Typography_1.default, { component: "span", sx: { fontSize: '14px', color: 'text.secondary' } },
                            react_1.default.createElement("strong", null,
                                (0, Lang_js_1.__)('Expired On'),
                                ":"),
                            " ",
                            data.twi.expired_on)))) : (react_1.default.createElement(Typography_1.default, { sx: { mt: '6px', color: 'error.main', fontWeight: 600, fontSize: '14px' } }, (0, Lang_js_1.__)('Not Yet Subscribed')))),
                react_1.default.createElement(Box_1.default, { sx: { display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'stretch' } },
                    react_1.default.createElement(Link_1.default, { href: data.twi.subscribed
                            ? '/app/twi/subscriptions?from=subscriptions'
                            : '/app/twi/subscribe?from=subscriptions', sx: actionLinkSx(false) }, data.twi.subscribed ? (0, Lang_js_1.__)('MANAGE') : (0, Lang_js_1.__)('SUBSCRIBE NOW')),
                    react_1.default.createElement(Link_1.default, { href: isGuest
                            ? "/app/students/login?previous_url=".concat(encodeURIComponent('/app/subscriptions/cart?product=twi-gift'))
                            : '/app/subscriptions/cart?product=twi-gift', sx: actionLinkSx(false) }, (0, Lang_js_1.__)('GIFT / EXTEND')))),
            react_1.default.createElement(ProductDetails, { info: data.product_info.twi }))));
};
var portalContainer = document.getElementById('student-subscriptions-portal');
if (portalContainer) {
    (0, mountIsland_1.mountIsland)(portalContainer, react_1.default.createElement(SubscriptionPortal, null));
}
exports.default = SubscriptionPortal;
